import BaseBehavior from '../../../framework/base/base';

export default class LightboxTrigger extends BaseBehavior {
	constructor(element) {
		super(element);

		this.addEventListeners();
	}

	addEventListeners() {
		this.addEventListener(this.element, 'click', e => {
			e.preventDefault();

			this.publish('/lightbox/open', {
				cssClass: this.element.getAttribute('data-css-class') || '',
				target: this.element.getAttribute('data-target'),
				title: this.element.getAttribute('data-title') || '',
				type: this.element.getAttribute('data-type') || 'id',
				rte: this.element.getAttribute('data-rte') || '',
				option: { image: '', title: '', label: '' }
			});
		});
	}

	removeEventListeners() {
		this.removeEventListener(this.element, 'click');
	}

	cleanup() {
		this.removeEventListeners();
	}
}
